import { createSelector } from '@ngrx/store';

export const getStreetsState = createSelector(
    (state: any) => state.streets,
    (state: any) => state.get('list')
);

export const getCreateStreetState = createSelector(
    (state: any) => state.streets,
    (state: any) => state.get('createStreet')
);

export const getUpdateStreetState = createSelector(
    (state: any) => state.streets,
    (state: any) => state.get('updateStreet')
);
 